import React from 'react';
import PropertyBase, { IBasePropertyProps } from './PropertyBase';
import Button from '../layout/Button';
import StepPicker from '../sequences/StepPicker';
import ModalManager from '../layout/ModalManager';
import Scenario from '../../classes/scenarioElements/Scenario';
import AnalyticsManager from '../../classes/AnalyticsManager';

interface IStepPropertyProps extends IBasePropertyProps
{
	value: string;
	onCommitCallback?: (value: string) => void;
	onChangeCallback?: (value: string) => void;
	emptyLabel?: string;
	multivalues?: boolean;
	filterCps?: boolean;
}

export default function StepProperty(props: IStepPropertyProps)
{
	let step = props.value ? Scenario.getStep(props.value) : null;
	if(step && step.isDisabledTrackersStep())
		step = null;

	const sequence = step?.sequence;

	let faceValue = props.multivalues ? "(Multiple Values)" :
		step ? step.name : 
			props.emptyLabel ? props.emptyLabel : "Select Step";

	if (!props.multivalues && sequence)
	{
		faceValue = sequence.name + " → " + faceValue;
	}

	const dataName = (props["data-name"] ? props["data-name"] + "-" : "") + "-step-property";

	return (
		<PropertyBase {...props}
			data-name={dataName + "-root"}
		>
			<Button data-name={dataName + "-button"}
				className={"propertyValueButton"}
				silent={true}
				label={faceValue}
				onClick={(e) =>
				{
					e.persist();
					ModalManager.addModal({
						content:
							<StepPicker
							  data-name={dataName + "-picker"}
							  value={props.value}
							  filterCps={props.filterCps}
							  onSelectedCallback={(id) =>
							  {
							    if (props.onCommitCallback)
							    {
							      AnalyticsManager.managedEvent('propertyChanged', 'propertyId', e.target["dataset"]?.name);
							      props.onCommitCallback(id);
							    }
							    else if (props.onChangeCallback)
							    {
							      AnalyticsManager.managedEvent('propertyChanged', 'propertyId', e.target["dataset"]?.name);
							      props.onChangeCallback(id);
							    }
							  }}
							/>
					});
				}}
			/>
		</PropertyBase>
	);
}